export default __webpack_public_path__ + "static/media/DefenderTemplate.3b44bb85.svg";